import React from 'react'
import styled from 'react-emotion'
import Helmet from 'react-helmet'

import Section from '../components/section/Section'
import Button from '../components/buttons/Button'
import { SectionTwoCol, SectionColumn } from '../components/section/SectionTwoCol'
import { TwoCol, LeftCol, RightCol, } from '../components/two-col'
import SectionHeader from '../components/section/SectionHeader'
import SectionPreHeader from '../components/section/SectionPreHeader'
import SubHeader from '../components/section/SubHeader'
import CalloutContainer from '../components/CalloutContainer'
import HubspotFormSection from '../components/forms/HubspotFormSection'

import heroImg from '../assets/clients/hero.jpg'
import ihgImg from '../assets/clients/clients-ihg.png'
import larkImg from '../assets/clients/clients-lark.png'
import accorImg from '../assets/clients/clients-accor.png'
import greentreeImg from '../assets/clients/clients-greentree.png'
import kanaImg from '../assets/clients/clients-kana.png'
import foursistersImg from '../assets/clients/clients-foursisters.png'
import seoHero from '../assets/clients/seo-hero.png'


class ClientsPage extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div>
        <Helmet
          title={'IHG + Whistle'}
          meta={[
            { name: 'og:title', content: 'IHG + Whistle' },
            { name: 'description', content: 'Trusted by big brands and independent boutiques.' },
            { name: 'og:description', content: 'Trusted by big brands and independent boutiques.' },
            { name: 'og:image', content: seoHero },
            { name: 'og:type', content: "website" },
            { name: 'og:locale', content: "en_US" },
          ]}
        />
        <TwoCol bgColor={'#fcc71b'}>
          <LeftCol bgColor={'#fcc71b'} skew color="#fff">
            <h1>Trusted By Brands<br/> To Independent<br/> Boutiques</h1>
            <SubHeader>From large hotel brands to small B&amp;Bs <br/>—Whistle is the premiere guest <br/>messaging platform for every<br/> hospitality company.</SubHeader>
            <CalloutContainer align={'left'}>
              <Button primary to="/schedule" icon>Book A Demo</Button>
            </CalloutContainer>
          </LeftCol>
          <RightCol image bgImgSrc={heroImg} />
        </TwoCol>
        <SectionTwoCol light>
          <SectionColumn center>
            <img src={ihgImg} alt="InterContinental Hotels Group Logo" />
          </SectionColumn>
          <SectionColumn>
            <SectionPreHeader align="center">Hotel Brand</SectionPreHeader>
            <SectionHeader align="center" lower>InterContinental Hotels Group</SectionHeader>
            <SubHeader align="center">Whistle is an approved vendor for IHG's EMEAA region. From the Holiday Inn brand, to Crowne Plaza and Intercontinental hotels - Whistle provides an unmatched experience for IHG hotels!</SubHeader>
          </SectionColumn>
        </SectionTwoCol>
        <SectionTwoCol>
          <SectionColumn>
            <SectionPreHeader align="center">Botique Hotels</SectionPreHeader>
            <SectionHeader align="center" lower>Lark Hotels</SectionHeader>
            <SubHeader align="center">A boutique collection in New England and beyond, with iconic destinations such as Nantucket, Portland Maine, Stowe, Napa, Mendocino and much more! Lark hotels utilize Whistle across all 28 hotels.</SubHeader>
          </SectionColumn>
          <SectionColumn>
            <img src={larkImg} alt="Lark Hotels Logo" />
          </SectionColumn>
        </SectionTwoCol>
        <SectionTwoCol light>
          <SectionColumn center>
            <img src={accorImg} alt="Accor Logo" />
          </SectionColumn>
          <SectionColumn>
            <SectionPreHeader align="center">Franchise Hotelier</SectionPreHeader>
            <SectionHeader align="center" lower>Accor</SectionHeader>
            <SubHeader align="center">Accor is the single largest hospitality company in Europe, and the sixth largest worldwide. Find out how major Accor brands across the world are using Whistle to elevate their guest experience!</SubHeader>
          </SectionColumn>
        </SectionTwoCol>
        <SectionTwoCol>
          <SectionColumn>
            <SectionPreHeader align="center">Independent Boutiques</SectionPreHeader>
            <SectionHeader align="center" lower>Four Sisters Inns</SectionHeader>
            <SubHeader align="center">Four Sisters Inns is a collection of 18 extraordinary boutique inns and hotels, located in California's most spectacular destinations. By fully integrating with their PMS and contactless check-in tools, Whistle has been key for Four Sisters Inns' operations.</SubHeader>
          </SectionColumn>
          <SectionColumn>
            <img src={foursistersImg} alt="Four Sisters InnsLogo" />
          </SectionColumn>
        </SectionTwoCol>
        <SectionTwoCol light>
          <SectionColumn center>
            <img src={kanaImg} alt="Kana Hotel Group Logo" />
          </SectionColumn>
          <SectionColumn>
            <SectionPreHeader align="center">Management Group</SectionPreHeader>
            <SectionHeader align="center">Kana Hotel Group</SectionHeader>
            <SubHeader align="center">With over 60 branded hotels under their management, Kana Hotel Group relies on Whistle to provide seamless messaging across their portfolio of branded hotels.</SubHeader>
          </SectionColumn>
        </SectionTwoCol>
        <SectionTwoCol>
          <SectionColumn>
            <SectionPreHeader align="center">MID-SCALE HOTELS</SectionPreHeader>
            <SectionHeader align="center" lower>GreenTree Inn</SectionHeader>
            <SubHeader align="center">GreenTree Inn is successful brand in Asia with over 2,500 hotels worldwide. What started as one hotel in Phoenix, has now quickly grown throughout the Southwest through corporate acquisition and franchise development.</SubHeader>
          </SectionColumn>
          <SectionColumn>
            <img src={greentreeImg} alt="GreenTree Inn Logo" />
          </SectionColumn>
        </SectionTwoCol>
        <HubspotFormSection
          primary
          id="book-demo"
          formId="7d86c04f-e98e-42eb-ae79-ff2b14c7605a"
          trackingId={process.env.ADWORDS_TRACKER_LEAD_FORM}
        />
      </div>
    )
  }
}
 
export default ClientsPage;


// WEBPACK FOOTER //
// ./src/pages/clients.js